import { useMemo } from 'react';
import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../queryKeys';
import { questionnaire } from '../Questionnaire';
import type {
  QuestionnaireResponsesQuery,
  QuestionnaireTemplateParams,
} from '../types';

export const useQuestionnaireTemplate = (params: QuestionnaireTemplateParams) =>
  useQuery({
    queryKey: [QUERY_KEYS.questionnaireTemplate, params],
    queryFn: async () => (await questionnaire.getTemplate(params)).data,
    enabled: !!params.templateKey && !!params.customerId,
  });

export const useQuestionnaireResponse = (responseId: number) =>
  useQuery({
    queryKey: [QUERY_KEYS.questionnaireResponse, responseId],
    queryFn: async () => (await questionnaire.getResponse(responseId)).data,
    enabled: !!responseId,
  });

export const useSubmitQuestionnaireResponse = () =>
  useMutation({
    mutationFn: questionnaire.submitResponse,
  });

export const useQuestionnaireResponses = (
  query: QuestionnaireResponsesQuery | undefined,
) => {
  const serialized = useMemo(
    () => (query ? JSON.stringify(query) : '__idle__'),
    [query],
  );

  return useQuery({
    queryKey: [QUERY_KEYS.questionnaireResponseList, serialized] as const,
    queryFn: async () => (await questionnaire.listResponses(query!)).data,
    enabled: !!query,
    placeholderData: keepPreviousData,
  });
};
